/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
let redirectUri = ""
if(process.env.NODE_ENV === "development") {
  redirectUri = "http://localhost:3000"
} else {
  redirectUri = "https://distributionslistor.svensktnaringsliv.se/"
}

export const msalConfig = {
    auth: {
        clientId: "9ad96527-2c8a-46b5-b189-17c613e534a6", // This is the ONLY mandatory field that you need to supply.
        authority: "https://login.microsoftonline.com/1d019c94-da7b-49c2-bf93-5ee1bb4b6882", // Defaults to "https://login.microsoftonline.com/common"
        redirectUri: redirectUri, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                      console.log(message);
                      return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read.All"]
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
 let endpointUri = ""
 if(process.env.NODE_ENV === "development") {
  endpointUri = "http://localhost:3080"
 } else {
  endpointUri = "https://snmo-dl-review-api.azurewebsites.net"
 }

export const protectedResources = {
    graphMe: {
      endpoint: "https://graph.microsoft.com/v1.0/me",
      scopes: ["User.Read", "User.Read.All"],
    },
    graphGetUsers: {
      endpoint: "https://graph.microsoft.com/v1.0/users",
      scopes: ["User.Read.All"],
    },
    retrieveDLData: {
      endpoint: endpointUri + "/api/retrieveDLdata",
      scopes: ["api://ff2a1a69-5c59-4410-a303-a9b6f57a8e64/access_as_user"], // e.g. api://xxxxxx/access_as_user
    },
    keepDL: {
      endpoint: endpointUri + "/api/keepDL",
      scopes: ["api://ff2a1a69-5c59-4410-a303-a9b6f57a8e64/access_as_user"],
    },
    removeDL: {
      endpoint: endpointUri + "/api/removeDL",
      scopes: ["api://ff2a1a69-5c59-4410-a303-a9b6f57a8e64/access_as_user"],
    },
    changeDLAction: {
      endpoint: endpointUri + "/api/changeDLAction",
      scopes: ["api://ff2a1a69-5c59-4410-a303-a9b6f57a8e64/access_as_user"],
    },
    retrieveOneDL: {
      endpoint: endpointUri + "/api/getOneDL",
      scopes: ["api://ff2a1a69-5c59-4410-a303-a9b6f57a8e64/access_as_user"],
    },
    setOwner: {
      endpoint: endpointUri + "/api/setOwner",
      scopes: ["api://ff2a1a69-5c59-4410-a303-a9b6f57a8e64/access_as_user"],
    }
}